import { Component, OnInit, ViewEncapsulation, ViewChild, Input, Output, EventEmitter, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { GlobalsService } from '../shared/services/globals.service';
import { SearchTarget } from '../shared/enums/SearchTarget';
import { DQOIService } from '../shared/services/DQOI.service';
import { DQOIToolbarEvent } from '../shared/models/DQOIToolbarEvent';
import { ToolbarEvent } from '../shared/enums/ToolbarEvent';

import { DQOISearchEvent } from '../shared/models/DQOISearchEvent';
import { CommonFunctions } from '../shared/static/common-functions';
import { BaseDQOIComponent } from '../shared/base-components/base-dqoi.component';
import { QuotesComponent } from '../quotes/quotes.component';
import { DispatchesComponent } from '../dispatches/dispatches.component';
import { OrdersComponent } from '../orders/orders.component';
import { InvoicesComponent } from '../invoices/invoices.component';
import { DQOIItem } from '../shared/models/DQOIItem';
import { DQOIMessage } from '../shared/models/DQOIMessage';
import { DQOIDisplayItem } from '../shared/models/DQOIDisplayItem';
import { MessageType } from '../shared/enums/MessageType';
import { CustomerService } from '../shared/services/customer.service';
import { DomSanitizer } from '@angular/platform-browser';
import { TabStripComponent, TabStripTabComponent } from '@progress/kendo-angular-layout';
import { BaseMessageInfo } from '../shared/models/BaseMessageInfo';
import { DispatchMessageInfo } from '../shared/models/DispatchMessageInfo';
import { DQOIMessageInfo } from '../shared/models/DQOIMessageInfo';
import { DQOIParam } from '../shared/models/DQOIParam';
import { InvoiceMessageInfo } from '../shared/models/InvoiceMessageInfo';
import { OrderMessageInfo } from '../shared/models/OrderMessageInfo';
import { DispatchesService } from '../shared/services/dispatches.service';
import { DispatchSaveParam } from '../shared/models/DispatchSaveParam';
import { CusLocAddrInfoBus } from '../shared/models/CusLocAddrInfoBus';
import { DQOIReferenceData } from '../shared/models/DQOIReferenceData';
import { DQOIReferenceDataQuery } from './state/dqoi-reference-data.query';
import { RefreshToken } from '../shared/models/RefreshToken';
import { CmProAuthService } from '@app/core/services';
import { UsersBus } from '../shared/models/UsersBus.model';
import { AppClaims } from '../shared/models/AppClaims';
import { UseCPLoader, ICPLoader } from '../shared/decorators/cploader/cploader-decorator';
import { IFeatureFlagSet } from '../shared/decorators/featureflags/featureflagset-decorator';
import { FeatureFlagService } from '../shared/services/feature-flag.service';
import { DispatchData } from '../shared/models/DispatchData';
import { DQOIDisplaySettings } from '../shared/models/DQOIDisplaySettings';
import { ConfirmDialogComponent, ConfirmDialogOptions } from '../shared/components/confirm-dialog/confirm-dialog.component';
import { ConfirmOutput } from '../shared/models/ConfirmOutput';
import { CPDialogResult } from '../shared/enums/CPDialogResult';
import { OpenSalesOrderMessage } from '../shared/models/OpenSalesOrderMessage';
import { popoutService } from '../shared/services/popout.service';

@UseCPLoader()
@Component({
    selector: 'dqoi',
    templateUrl: './dqoi.component.html',
    styleUrls: ['./dqoi.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class DQOIComponent implements OnInit, OnDestroy {
    compLoader: ICPLoader = this as any;
    @ViewChild('dqoiTabStrip') public tabstrip: TabStripComponent;
    @ViewChild('dqoiDispatch') protected dqoiDispatch: DispatchesComponent;
    @ViewChild('dqoiQuote') protected dqoiQuote: QuotesComponent;
    @ViewChild('dqoiOrder') protected dqoiOrder: OrdersComponent;
    @ViewChild('dqoiInvoice') protected dqoiInvoice: InvoicesComponent;
    @ViewChild('cnfSalesOrderDialog') protected cnfDialog: ConfirmDialogComponent;
    protected _id: any;
    @Input() set id(id: any) {
        if (CommonFunctions.hasValue(id)) {
            this.setupFromId(id);
        }
    }
    @Input() target: string = "D";
    @Input() collapsible: boolean = false;
    @Input() dqoiDispatchSettings: DispatchData = null;
    //@Input() dqoiDisplaySettings: DQOIDisplaySettings = null;

    @Input() set DQOIInput(item: DQOIItem) {
        if (!CommonFunctions.hasValue(this.dqoiItem)) {
            this.dqoiItem = item;
            this.setup(item);
        }
    }
    @Output() dqoiMessage: EventEmitter<DQOIMessage> = new EventEmitter<DQOIMessage>();
    private subs_featureFlagSet: Subscription; //place as class variable
    compFeatureFlagSet: IFeatureFlagSet = this as any;
    rights: AppClaims = new AppClaims();
    subs_data: Subscription;
    public expansionPanelToggle: boolean = true;
    logo: any;
    dqoiLoader: boolean = true;
    cusLocAddrInfo: CusLocAddrInfoBus;
    sendDQOIMessage(message: DQOIMessage) {
        this.dqoiMessage.emit(message);

    }
    get hasLogo(): boolean {
        return CommonFunctions.hasValue(this.logo);
    }

    onDQOIMessage(e: DQOIMessage) {
        if (e.messageType === MessageType.customerAndLocation) {
            this.displayItem.customer = e.customer;
            this.displayItem.location = e.location;
            if (CommonFunctions.hasGuidValue(e.locationId)) {
                this.svc_cust.getCusLocAddrInfo(e.locationId).subscribe((info: BaseMessageInfo) => {
                    if (!info.saveError) {
                        this.cusLocAddrInfo = info.primaryReturn;
                        this.logo = this.sanitizer.bypassSecurityTrustResourceUrl("data:image/png;base64," + this.cusLocAddrInfo.logo);

                    }
                });
            }
            else {
                this.logo = null;
            }
        }
        else if (e.messageType === MessageType.createOrderFromParts) {
            this.createOrderFromParts(e.messageData);
        }
        else if (e.messageType === MessageType.goTo) {
            this.goTo(e.messageData);
        }
        else if (e.messageType === MessageType.gotoInvoice) {
            this.gotoInvoice(e.messageData);
        }
        else if (e.messageType === MessageType.goToNewDQOI) {
            this.setupFromId(e.messageData);
        }
        else if (e.messageType === MessageType.miniLoaderOn) {
            this.miniLoaderOn();
        }
        else if (e.messageType === MessageType.miniLoaderOff) {
            this.miniLoaderOff();
        }
        else if (e.messageType === MessageType.getDQOIItem) {
            this.refreshDQOIItem(e.messageData);
        }
        else if (e.messageType === MessageType.createInvoiceFromOrderBill) {
            this.createInvoiceFromOrderBillId(e.messageData);
        }

    }
    miniLoaderOn() {
        this.dqoiLoader = true;
    }
    miniLoaderOff() {
        this.dqoiLoader = false;

    }
    displayItem: DQOIDisplayItem = new DQOIDisplayItem();
    dqoiItem: DQOIItem = null;
    get hasDQOIItem(): boolean {
        return CommonFunctions.hasValue(this.dqoiItem);
    }
    get dqoiIndex(): number {
        return this.hasDQOIItem ? this.dqoiItem.index : -1;
    }
    getDQOIItem(): DQOIItem {
        let item: DQOIItem = null;
        if (this.hasDQOIItem) {
            item = this.svc_dqoi.getDQOIItem(this.dqoiIndex);
        }
        return item;
    }

    searchTarget: SearchTarget = SearchTarget.dispatch;
    subs_toolbarEvent: Subscription;
    readOnly: boolean = true;
    hasData: boolean = false;
    get canEdit(): boolean {
        return this.readOnly && this.hasData;
    }
    get canClear(): boolean {
        return this.readOnly && this.hasData;
    }
    constructor(private svc_dqoi: DQOIService, private svc_cust: CustomerService, private featureFlagService: FeatureFlagService, private sanitizer: DomSanitizer, private svc_dispatch: DispatchesService, private qry_rd: DQOIReferenceDataQuery, private authService: CmProAuthService, private globals: GlobalsService, public popout: popoutService) {
        this.subs_featureFlagSet = this.featureFlagService.featureFlagSets.subscribe(data => {
            this.compFeatureFlagSet = data;
        });
    }
    subs_dataRef: Subscription;
    get referenceData(): DQOIReferenceData {
        return BaseDQOIComponent._referenceData;
    }
    get hasReferenceData(): boolean {
        let retVal: boolean = false;
        try {
            retVal = this.referenceData !== undefined && this.referenceData !== null && CommonFunctions.hasArrayElementValue(this.referenceData.dispatchStatus) ? true : false;
        }
        catch {
            retVal = false;
        }
        return retVal;

    }
    serviceMode: any;
    setServiceMode(): any {
        return !this.hasReferenceData || this.rights.FG2RegularAccess === true ? "0" : this.referenceData.serviceMode;
    }
    priorityClass() {
        let id: string = '';
        if (CommonFunctions.hasValue(this.dqoiItem)) {
            id = CommonFunctions.getStringValueIfNull(this.dqoiItem.priorityId, '').toUpperCase();
        }
        switch (id) {
            case '3FE257A3-0F32-4C46-8424-8AC3B979D3A8': return 'dqoi-panel-priority priority overtime-approval'; // Overtime Approved
            case '82BB9C7E-6FE5-4772-B10E-591148698068': return 'dqoi-panel-priority priority hot-parts'; // HOT PARTS - ASAP
            case '8DF31E86-C0BD-4340-852F-41BFBC07937B': return 'dqoi-panel-priority priority high'; // High
            case 'F76D9D14-18D3-4931-87DF-A63EE4E526BD': return 'dqoi-panel-priority priority normal'; // Normal
            case '9B33B03A-3418-4335-B3F1-0E95E772A895': return 'dqoi-panel-priority priority pm'; // PM
            case 'F96B1A29-BA30-469E-84FD-8937A3D8CAF4': return 'dqoi-panel-priority priority warranty'; // Warranty (Hot)
            case 'DD87160B-0775-4DAD-B070-D9021D099F3D': return 'dqoi-panel-priority priority locked-scheduled'; // LOCKED - SCHEDULED
            case '3225ADA7-56A5-49C2-88D2-D3403340B8F8': return 'dqoi-panel-priority priority'; // Special Equipment
            default: return 'dqoi-panel-priority priority';
        }
    }
    removeDQOI() {
        let message: DQOIMessage = new DQOIMessage();
        message.messageType = MessageType.close;
        message.messageData = this.dqoiItem.index;
        if (CommonFunctions.hasValue(this.dqoiDispatch)) {
            this.dqoiDispatch.close();
        }
        if (CommonFunctions.hasValue(this.dqoiQuote)) {
            this.dqoiQuote.close();
        }
        if (CommonFunctions.hasValue(this.dqoiOrder)) {
            this.dqoiOrder.close();
        }
        if (CommonFunctions.hasValue(this.dqoiInvoice)) {
            this.dqoiInvoice.close();
        }
        this.sendDQOIMessage(message);
    }
    ngOnDestroy(): void {
        this.authService.unsubscribeToLoginEvents();
        CommonFunctions.unsubscribe(this.subs_createNewDispatchFromQuote);
        CommonFunctions.unsubscribe(this.subs_createNewDispatchFromInvoice);
        CommonFunctions.unsubscribe(this.subs_data);
        CommonFunctions.unsubscribe(this.subs_createSalesOrder);
    }
    ngOnInit() {
        this.subs_dataRef = this.qry_rd.ensureRefDataIsLoaded(this.globals.companyId).subscribe();

        this.subs_toolbarEvent = this.svc_dqoi.toolbarEvent$.subscribe((data: DQOIToolbarEvent) => {
            if (data !== null && data.isToolbarOnly) {
                this.hasData = data.hasData;
                this.readOnly = data.readOnly;
            }
        });
        this.authService.subscribeToLoginEvents((user: UsersBus) => {
            if (user) {
                this.rights = user.appClaims;
                this.serviceMode = this.setServiceMode();
            }
        });

    }
    expandedSearch: boolean = false;

    getTargetFromId(id: string): SearchTarget {
        let target: SearchTarget = SearchTarget.any;
        let arr = id.split(":");
        if (CommonFunctions.hasArrayElementValue(arr)) {
            switch (arr[0]) {
                case "1":
                    target = SearchTarget.dispatch;
                    break;
                case "2":
                    target = SearchTarget.quote;
                    break;
                case "3":
                    target = SearchTarget.order;
                    break;
                case "4":
                    target = SearchTarget.invoice;
                    break;

            }
        }
        return target;
    }
    setupFromId(id: any) {
        this.svc_dispatch.getDQOIItem(id).subscribe((data: DQOIItem) => {
            data.searchTarget = this.getTargetFromId(id);
            let dataObj: DQOIItem = this.svc_dqoi.addDQOIItem(data);
            this.setup(dataObj);
        });

    }
    canSeeInvoiceTab(): boolean {
        let can: boolean = false;
        if (this.dqoiItem) {
            if (this.rights && this.rights.ViewInvoices && (this.dqoiItem.hasInvoiceId || this.rights.CreateInvoices) && this.serviceMode != "1") {
                can = true;
            }
        }
        return can;
    }
    canSeeQuoteTab(): boolean {
        let can: boolean = false;
        if (this.dqoiItem) {
            if (this.rights && this.rights.ViewQuotes && (this.dqoiItem.hasQuoteId || this.rights.MaintainQuotes)) {
                can = true;
            }
        }
        return can;
    }
    canSeeOrderTab(): boolean {
        let can: boolean = false;
        if (this.dqoiItem) {
            if (this.rights && this.rights.ViewOrders && (this.dqoiItem.hasOrderId || this.rights.MaintianOrders)) {
                can = true;
            }
        }
        return can;
    }
    setup(data: DQOIItem) {
        let se: DQOISearchEvent = new DQOISearchEvent();
        if (CommonFunctions.hasValue(data)) {
            let tempDQOI = this.svc_dqoi.getDQOIItem(data.index);
            if (!CommonFunctions.hasValue(tempDQOI)) {
                this.dqoiItem = new DQOIItem(data);
                this.svc_dqoi.setDQOIItem(data);
            }
            else {

                if (!this.hasDQOIItem) {
                    this.dqoiItem = new DQOIItem(data);
                    this.svc_dqoi.setDQOIItem(data);
                }
                else {
                    if (!se.isNew) { this.dqoiItem = new DQOIItem(this.dqoiItem); }
                }
            }
            this.searchTarget = data.searchTarget;
            se.isNew = this.dqoiItem.isNew;
            se.searchTarget = data.searchTarget;
            se.dispatchId = data.dispatchId;
            se.dqoiItem = data;
            switch (data.searchTarget) {
                case SearchTarget.dispatch:
                    break;
                case SearchTarget.quote:
                    se.quoteNumber = data.number;
                    break;
                case SearchTarget.order:
                    se.orderNumber = data.number;
                    break;
                case SearchTarget.invoice:
                    se.invoiceNumber = data.number;
                    break;
            }
        }
        this.svc_dqoi.nextSearchEvent(se);
        if (se.isNew) {
            this.miniLoaderOff();
        }
    }

    get salesOrderTitle(): string {
        if (this.compFeatureFlagSet['ui-hide-zuggit-menu-items-extended'] && this.globals.user.isZuggitUser && this.dqoiDispatchSettings?.dqoiDisplaySettings?.useCPRefData)
            { return this.hasDQOIItem && this.dqoiItem.hasSalesOrder ? 'Sale' : 'Create Sales Order'; }
        else { return ""; }
    }
    get dispatchTitle(): string {
        if (this.compFeatureFlagSet['ui-hide-zuggit-menu-items-extended'] && this.globals.user.isZuggitUser && !this.dqoiDispatchSettings?.dqoiDisplaySettings?.useCPRefData)
        { return this.hasDQOIItem && this.dqoiItem.hasDispatch ? 'Sale' : 'Create Sale'; }
        else { return this.hasDQOIItem && this.dqoiItem.hasDispatch ? 'Dispatch' : 'Create Dispatch'; }
    }
    get quoteTitle(): string {
        return (this.hasDQOIItem && this.dqoiItem.hasQuote) || this.serviceMode === "1" ? 'Quote' : 'Create Quote';
    }
    get orderTitle(): string {
        return (this.hasDQOIItem && this.dqoiItem.hasOrder) || this.serviceMode === "1" ? 'Order' : 'Create Order';
    }
    get invoiceTitle(): string {
        return (this.hasDQOIItem && (this.dqoiItem.hasInvoice ||  (this.compFeatureFlagSet['ui-hide-zuggit-menu-items-extended']))) ? 'Invoice' : 'Create Invoice';
    }
    protected getFromId(fromTarget: SearchTarget, item: DQOIItem): any {
        let fromId: any = null;
        switch (fromTarget) {
            case SearchTarget.dispatch:
                fromId = item.dispatchId;
                break;
            case SearchTarget.quote:
                fromId = item.quoteId;
                break;
            case SearchTarget.order:
                fromId = item.orderId;
                break;
            case SearchTarget.invoice:
                fromId = item.invoiceId;
                break;
        }
        return fromId;
    }
    setTab(code: string, e) {
        let item: DQOIItem = this.svc_dqoi.getDQOIItem(this.dqoiItem.index);
        this.dqoiItem = new DQOIItem(item);
        let currSearchTarget: SearchTarget = this.searchTarget;

        console.log("setTab-b: ", code);

        if (!this.selectingTabProgramatically && CommonFunctions.hasValue(item)) {
            switch (code.toUpperCase()) {
                case "CREATE SALE":
                case "CREATE DISPATCH":
                    this.searchTarget = SearchTarget.dispatch;
                    if (e) {
                        e.preventDefault();
                    }
                    this.createDispatch(currSearchTarget);
                    break;
                case "SALE":
                case "DISPATCH":
                    this.searchTarget = SearchTarget.dispatch;
                    this.dqoiDispatch.checkChange(item.index, SearchTarget.dispatch);
                    break;
                case "CREATE QUOTE":
                    console.log("setTab-c: ", code);
                    this.searchTarget = SearchTarget.quote;
                    this.createQuote(currSearchTarget);
                    break;
                case "QUOTE":
                    this.searchTarget = SearchTarget.quote;
                    this.dqoiQuote.checkChange(item.index, SearchTarget.quote);
                    break;
                case "CREATE ORDER":
                    if (e) {
                        e.preventDefault();
                    }
                    this.searchTarget = SearchTarget.order;
                    this.createOrder(currSearchTarget);
                    break;
                case "ORDER":
                    this.searchTarget = SearchTarget.order;
                    this.dqoiOrder.checkChange(item.index, SearchTarget.order);
                    break;
                case "CREATE INVOICE":
                    if (e) {
                        e.preventDefault();
                    }
                    if (this.dqoiItem.dispatchId) {
                        this.canCreate(e, this.dqoiItem.dispatchId, SearchTarget.dispatch, SearchTarget.invoice);
                    }
                    break;
                case "INVOICE":
                    this.searchTarget = SearchTarget.invoice;
                    this.dqoiInvoice.checkChange(item.index, SearchTarget.invoice);
                    break;
            }
            //           this.selectingTabProgramatically = false;
        }
        this.selectingTabProgramatically = false;
        //this.searchComp.searchTargetChanged(this.searchTarget);
    }
    uiPickTab(index: number) {
        let tabIndex = this.findTabFromPassedPseudoIndex(index);
        this.tabstrip.selectTab(tabIndex);
        let tab: TabStripTabComponent = this.tabstrip.tabs.find(s => s.selected == true);
        console.log("uiPickTab: ", tabIndex, tab, tab.title);
        this.setTab(tab.title, null);
    }
    arrTabIndexTitlesByPseudoIndex: string[] = ['Dispatch', 'Quote', 'Order', 'Invoice'];
    
    
    findTabFromPassedPseudoIndex(pseudoIndex: number): number {
        //0-Dispatch, 1-Quote, 2-Order, 3-Invoice
        if (this.compFeatureFlagSet['ui-hide-zuggit-menu-items-extended']) { this.arrTabIndexTitlesByPseudoIndex[0] = 'Sale' }

        let tabTitle: string = this.arrTabIndexTitlesByPseudoIndex[pseudoIndex];
        for (let i = 0; i < this.tabstrip.tabs.length; i++) {
            let tabStripTab: TabStripTabComponent = this.tabstrip.tabs.toArray()[i];
            if (tabStripTab) {
                if (tabStripTab.title.includes(tabTitle)) {
                    pseudoIndex = i;
                    break;
                }
            }
        }
        return pseudoIndex;
    }
    canCreate(e: any, fromId: any, fromSearchTarget: SearchTarget, toSearchTarget: SearchTarget) {
        let param: DQOIMessageInfo = new DQOIMessageInfo();
        param.fromSearchTarget = fromSearchTarget;
        param.toSearchTarget = toSearchTarget;
        param.fromId = fromId;
        this.svc_dqoi.canCreate(param).subscribe((info: DQOIMessageInfo) => {
            if (info.canCreate) {
                //set tab with code
                this.createInvoice(fromSearchTarget);
            } else {
                this.globals.notifyError("There was an Error Trying to Create Invoice: " + info.message,  true);
            }
        });
    }
    selectingTabProgramatically: boolean = false;
    getTabIndexFromTarget(target: SearchTarget) {
        let tabIndex: number = 0;
        switch (target) {
            case SearchTarget.dispatch:
                break;
            case SearchTarget.quote:
                tabIndex = 1;
                break;
            case SearchTarget.order:
                tabIndex = 2;
                break;
            case SearchTarget.invoice:
                tabIndex = 3;
                break;
        }
        return tabIndex;
    }
    createQuote(fromSearchTarget: SearchTarget) {
        if (fromSearchTarget === SearchTarget.dispatch && this.dqoiItem.hasDispatchId) {
            this.createQuoteFromDispatch();
        }
        else if (fromSearchTarget === SearchTarget.invoice && this.dqoiItem.hasInvoiceId) {
            this.createQuoteFromInvoice();
        }
    }
    createDispatch(fromSearchTarget: SearchTarget) {
        if (fromSearchTarget === SearchTarget.quote && this.dqoiItem.hasQuoteId) {
            this.createDispatchFromQuote();
        }
        else if (fromSearchTarget === SearchTarget.invoice && this.dqoiItem.hasInvoiceId) {
            this.createDispatchFromInvoice();
        }
    }
    subs_createNewDispatchFromQuote: Subscription;
    subs_createNewDispatchFromInvoice: Subscription;
    createDispatchFromQuote() {
        this.compLoader.cpLoaderOn();
        CommonFunctions.unsubscribe(this.subs_createNewDispatchFromQuote);
        this.subs_createNewDispatchFromQuote = this.svc_dqoi.createNewDispatchFromQuote(this.dqoiItem.quoteId).subscribe((info: DispatchMessageInfo) => {
            if (info.saveError) {

            }
            else {
                let param: DQOIParam = new DQOIParam();
                param.code = "CRFROMQUOTE";
                param.data = info;
                param.dqoiItem = this.getDQOIItem(); // this.dqoiItem;
                this.dqoiDispatch.setup(param, param.code);
                let index = this.getTabIndexFromTarget(SearchTarget.dispatch);
                this.selectingTabProgramatically = true;
                this.tabstrip.selectTab(index);
            }
            this.compLoader.cpLoaderOff();
        });
    }
    createDispatchFromInvoice() {
        this.compLoader.cpLoaderOn();
        CommonFunctions.unsubscribe(this.subs_createNewDispatchFromInvoice);
        this.subs_createNewDispatchFromInvoice = this.svc_dqoi.createNewDispatchFromInvoice(this.dqoiItem.invoiceId).subscribe((info: DispatchMessageInfo) => {
            if (info.saveError) {

            }
            else {
                let param: DQOIParam = new DQOIParam();
                param.code = "CRFROMINVOICE";
                param.data = info;
                param.dqoiItem = this.getDQOIItem(); // this.dqoiItem;
                this.dqoiDispatch.setup(param, param.code);
                let index = this.getTabIndexFromTarget(SearchTarget.dispatch);
                this.selectingTabProgramatically = true;
                this.tabstrip.selectTab(index);
            }
            this.compLoader.cpLoaderOff();
        });
        //        this.dqoiDispatch.setup(info, "CRFROMQUOTE");
    }
    createInvoiceFromQuote() {
        this.compLoader.cpLoaderOn();
        this.svc_dqoi.createNewInvoiceFrom(SearchTarget.quote, this.dqoiItem.quoteId).subscribe((info: InvoiceMessageInfo) => {
            if (info.saveError) {
                this.globals.notifyError("There was an Error Trying to Create Invoice From Quote: " + info.message, true);
            }
            else {
                let param: DQOIParam = new DQOIParam();
                param.code = "CRFROMQUOTE";
                param.data = info;
                param.dqoiItem = this.getDQOIItem(); // this.dqoiItem;
                this.dqoiInvoice.setup(param, param.code);
                let index = this.getTabIndexFromTarget(SearchTarget.invoice);
                this.selectingTabProgramatically = true;
                this.tabstrip.selectTab(index);
            }
            this.compLoader.cpLoaderOff();
        });
    }
    createInvoiceFromDispatch() {
        this.compLoader.cpLoaderOn();
        this.svc_dqoi.createNewInvoiceFrom(SearchTarget.dispatch, this.dqoiItem.dispatchId).subscribe((info: InvoiceMessageInfo) => {
            if (!info.saveError) {
                let param: DQOIParam = new DQOIParam();
                param.code = "CRFROMDISPATCH";
                param.data = info;
                param.dqoiItem = this.getDQOIItem(); // this.dqoiItem;
                this.dqoiInvoice.setup(param, "CRFROMDISPATCH");
                let index = this.getTabIndexFromTarget(SearchTarget.invoice);
                this.selectingTabProgramatically = true;
                this.tabstrip.selectTab(index);
                this.searchTarget = SearchTarget.invoice;
            }
            else {
                this.globals.notifyError("Error Creating Invoice: " + info.message, true);
            }
            this.compLoader.cpLoaderOff();
        });

    }
    createInvoiceFromOrderBillId(data: any) {
        this.compLoader.cpLoaderOn();
        this.svc_dqoi.createNewInvoiceFrom(SearchTarget.orderBill, data).subscribe((info: InvoiceMessageInfo) => {
            if (!info.saveError) {
                let param: DQOIParam = new DQOIParam();
                param.code = "CRFROMORDERBILL";
                param.data = info;
                param.dqoiItem = this.getDQOIItem(); // this.dqoiItem;
                this.dqoiInvoice.setup(param, "CRFROMORDERBILL");
                let index = this.getTabIndexFromTarget(SearchTarget.invoice);
                this.selectingTabProgramatically = true;
                this.tabstrip.selectTab(index);
                this.searchTarget = SearchTarget.invoice;
            }
            else {
                this.globals.notifyError("Error Creating Invoice: " + info.message, true);
            }
            this.compLoader.cpLoaderOff();
        });

    }
    createInvoice(fromSearchTarget: SearchTarget) {
        if (this.dqoiItem.hasDispatchId) {
            this.createInvoiceFromDispatch();
        }
    }
    createQuoteFromDispatch() {
        this.dqoiQuote.setup(this.dqoiItem, "CRFROMDISPATCH");
    }
    createQuoteFromInvoice() {
        this.dqoiQuote.setup(this.dqoiItem, "CRFROMINVOICE");
    }
    createOrderFromQuote() {
        this.compLoader.cpLoaderOn();
        this.svc_dqoi.createNewOrderFromQuote(this.dqoiItem.quoteId).subscribe((info: OrderMessageInfo) => {
            if (!info.saveError) {
                let param: DQOIParam = new DQOIParam();
                param.code = "CRFROMQUOTE";
                param.data = info;
                param.dqoiItem = this.getDQOIItem(); // this.dqoiItem;
                this.dqoiOrder.setup(param, param.code);
                let index = this.getTabIndexFromTarget(SearchTarget.order);
                this.selectingTabProgramatically = true;
                this.tabstrip.selectTab(index);
            }
            this.compLoader.cpLoaderOff();
        });
    }
    createOrderFromDispatch() {
        this.compLoader.cpLoaderOn();
        this.svc_dqoi.createNewOrderFromDispatch(this.dqoiItem.dispatchId).subscribe((info: OrderMessageInfo) => {
            if (!info.saveError) {
                let param: DQOIParam = new DQOIParam();
                param.code = "CRFROMDISPATCH";
                param.data = info;
                param.dqoiItem = this.getDQOIItem(); // this.dqoiItem;
                this.dqoiOrder.setup(param, param.code);
                let index = this.getTabIndexFromTarget(SearchTarget.order);
                this.selectingTabProgramatically = true;
                this.tabstrip.selectTab(index);
            }
            this.compLoader.cpLoaderOff();
        });

    }
    createOrder(fromSearchTarget: SearchTarget) {
        if (fromSearchTarget === SearchTarget.quote && this.dqoiItem.hasQuoteId) {
            this.createOrderFromQuote();
        }
        else if (fromSearchTarget === SearchTarget.dispatch && this.dqoiItem.hasDispatchId) {
            this.createOrderFromDispatch();
        }
    }
    setToolbar() {

    }
    onTabSelect(e: any, tabstrip: any) {
        console.log("dqoi->ontabsel: ", e);
        this.setTab(e.title, e);
    }
    new() {
        this.svc_dqoi.nextToolbarEvent({ isToolbarOnly: false, searchTarget: this.searchTarget, toolbarEvent: ToolbarEvent.new, readOnly: false, hasData: true, data: null, index: null });
        this.readOnly = false;
    }
    edit() {
        this.svc_dqoi.nextToolbarEvent({ isToolbarOnly: false, searchTarget: this.searchTarget, toolbarEvent: ToolbarEvent.edit, readOnly: false, hasData: true, data: null, index: null });
        this.readOnly = false;
    }
    save() {
        this.svc_dqoi.nextToolbarEvent({ isToolbarOnly: false, searchTarget: this.searchTarget, toolbarEvent: ToolbarEvent.save, readOnly: true, hasData: true, data: null, index: null });
        this.readOnly = true;
    }
    cancel() {
        this.svc_dqoi.nextToolbarEvent({ isToolbarOnly: false, searchTarget: this.searchTarget, toolbarEvent: ToolbarEvent.cancel, readOnly: true, hasData: true, data: null, index: null });
        this.readOnly = true;
    }
    clear() {
        this.svc_dqoi.nextToolbarEvent({ isToolbarOnly: false, searchTarget: this.searchTarget, toolbarEvent: ToolbarEvent.clear, readOnly: true, hasData: false, data: null, index: null });
        this.readOnly = true;
    }
    addNote() {

    }
    handleFilter(filter: string) {
    }
    public testValue: string = "";
    public listItems: Array<string> = ["Baseball", "Basketball", "Cricket", "Field Hockey", "Football", "Table Tennis", "Tennis", "Volleyball", "Table Jacks"];
    panelOpened() {
    }
    panelClosed() {
    }
    gotoInvoice(id: string) {
        var data = new DQOIParam();
        data.id = id;
        data.code = "GOTO";
        data.target = SearchTarget.invoice;
        this.dqoiInvoice.setup(data, data.code);
        let index = this.getTabIndexFromTarget(SearchTarget.invoice);
        this.selectingTabProgramatically = true;
        this.tabstrip.selectTab(index);
    }
    goTo(data: DQOIParam) {
        switch (data.target) {
            case SearchTarget.order:
                this.dqoiOrder.setup(data, data.code);
                let index = this.getTabIndexFromTarget(SearchTarget.order);
                this.selectingTabProgramatically = true;
                this.tabstrip.selectTab(index);
                break;
            case SearchTarget.invoice:
                this.dqoiInvoice.setDQOIIndex(this.dqoiItem.index);
                this.dqoiInvoice.setup(data, data.code);
                index = this.getTabIndexFromTarget(SearchTarget.invoice);
                this.selectingTabProgramatically = true;
                this.tabstrip.selectTab(index);
                break;
        }
    }
    createOrderFromParts(data: any) {
        this.compLoader.cpLoaderOn();
        let param: DispatchSaveParam = new DispatchSaveParam(null);
        param.partsReq = data;
        this.svc_dqoi.createNewFromDispatchPartsReq(param).subscribe((info: OrderMessageInfo) => {
            if (!info.saveError) {
                let param: DQOIParam = new DQOIParam();
                param.code = "CRFROMPARTS";
                param.data = info;
                param.dqoiItem = this.getDQOIItem(); //  this.dqoiItem;
                this.dqoiOrder.setup(param, param.code);
                let index = this.getTabIndexFromTarget(SearchTarget.order);
                this.selectingTabProgramatically = true;
                this.tabstrip.selectTab(index);
            }

        });
        this.compLoader.cpLoaderOff();
    }
    toggleExpansion() {
        this.expansionPanelToggle == !this.expansionPanelToggle;
    }
    dqoiItemFullyLoaded: boolean = false;
    refreshDQOIItem(token: RefreshToken) {
        this.dqoiItemFullyLoaded = false;
        let item: DQOIItem = this.svc_dqoi.getDQOIItem(token.dqoiIndex);
        let idTarget = token.target + ":" + token.id;
        if (!CommonFunctions.hasGuidValue(token.id)) {
            if (item.hasDispatchId) {
                idTarget = item.target + ":" + item.dispatchId;
            }
        }
        this.svc_dqoi.getDQOITemFromDb(idTarget).subscribe((newData: DQOIItem) => {
            newData.index = this.dqoiIndex;
            this.svc_dqoi.setDQOIItem(newData);
            this.dqoiItem = new DQOIItem(newData);
            this.dqoiItemFullyLoaded = true;
        });
    }

    createZuggitSalesOrderForCPDispatch(dispatchId: string, dispatchNumber: string) {
        if (!this.dqoiItem.hasSalesOrder) {
            const opt = new ConfirmDialogOptions();
            opt.title = "Create Sales Order from Dispatch?";
            opt.message = `Are you sure you want to create a sales order from Climate Pros dispatch: ${dispatchNumber}?`;
            opt.okButtonText = "Create Sales Order";
            opt.cancelButtonText = "Cancel";
            opt.data = { dispatchId: dispatchId, dispatchNumber: dispatchNumber };
            this.cnfDialog.showWithOverrides(opt);
        } else {
            const message = new OpenSalesOrderMessage();
            message.action = 'openSalesOrder';
            message.salesOrderId = this.dqoiItem.linkedSalesOrderId;
            message.salesOrderNumber = this.dqoiItem.linkedSalesOrderNumber;
            message.dispatchId = this.dqoiItem.dispatchId;
            message.dispatchNumber = this.dqoiItem.dispatchNumber;
            this.safePostToParent(message);
        }
    }

    subs_createSalesOrder: Subscription;

    confirmCreateSalesOrderDialog(data: ConfirmOutput) {
        //alert(JSON.stringify(data));
        if (data.dialogResult === CPDialogResult.ok) {
            this.subs_createSalesOrder = this.svc_dispatch.createSalesOrderFromDispatch(data.data.dispatchId).subscribe((data: string) => {
                //send message to dashboard component to open 
                const message = new OpenSalesOrderMessage();
                message.action = 'openSalesOrder';
                message.salesOrderId = data;//this.dqoiItem.linkedSalesOrderId;
                message.dispatchId = this.dqoiItem.dispatchId;
                this.safePostToParent(message);
                
            });
        }
    }
    private onPopoutLinkClick(url: string) {
        this.popout.openOrReuse(url); // reuses the window; loads new URL in it
    }
    private safePostToParent(message: OpenSalesOrderMessage) {
        window.opener?.postMessage(message, window.location.origin);
    }
}
